import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const schoolResourceApi = createAsyncThunk(
    'auth/schoolResources',
    async (data, { rejectWithValue }) => {
        try {
            const paramsData = new URLSearchParams(data);
            const response = await AuthAxios.get(apiRoutes.schoolProcessList, { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const schoolResourceSlice = createSlice({
    name: 'schoolResource',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(schoolResourceApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(schoolResourceApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count

        })
        builder.addCase(schoolResourceApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const schoolResourceReducer = schoolResourceSlice.reducer